<template>
    <div class="heading">
        <span class="title">{{ title }}</span>
        <b-dropdown
            v-if="options.length > 0 && !isLoadingOptions"
            toggle-class="text-decoration-none"
            no-caret
            right
            size="sm"
        >
            <template v-slot:button-content>
                <i class="cus-cog-down"></i>
            </template>

            <b-dropdown-item
                v-for="(option, index) in options"
                :key="index"
                href="#"
                @click.stop="option.onclick"
            >
                <i :class="option.icon"></i>
                {{ option.label }}
            </b-dropdown-item>
        </b-dropdown>
        <b-dropdown
            v-else-if="isLoadingOptions"
            toggle-class="text-decoration-none"
            no-caret
            right
            size="sm"
            disabled
        >
            <template v-slot:button-content>
                <img class="spinner" src="assets/ajax-spinner.gif" />
            </template>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: "panel-heading",
    props: {
        title: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: false,
            default: () => [] // return empty array
        },
        isLoadingOptions: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.heading {
    display: grid;
    grid-template-columns: 1fr 32px;
    padding: 0px 15px;
    margin-bottom: 10px;
}
.title {
    font-weight: bold;
    font-size: 1.2em;
}
</style>
